import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { RELATION_TYPES_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const RelationTypesService = ComposedComponent =>
  reduxFetch([
    {
      resource: RELATION_TYPES_RESOURCE,
      method: 'get',
      request: t => ({
        url: apiRoutes.relationTypes(),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getRelationTypesFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RelationTypesService;
